import * as React from 'react'
import * as styles from '../../assets/styles.module.scss'
import { default as Header } from '../../common/header'
import { default as Footer } from '../../common/footer'

interface Props {}
interface State {
    preset: {
        title: string
        price: number
        sku: string
    }
}

const _PRESETS = {
    'wander-wonder': {
        title: 'Wander Wonder Travel Preset Pack',
        price: 25.00,
        sku: `sku_FkhsKloW5aG6CY`
    }
}

export default class Page extends React.Component<Props, State> {

    constructor(props: any) {
        super(props)

        this.state = {
            preset: _PRESETS['wander-wonder']
        }

        this._goCheckout = this._goCheckout.bind(this)
    }

    // componentDidMount() {
    //     if (process.env.NODE_ENV === `production` && typeof window !== undefined) {
    //         gtag('event', 'view_item', {
    //             items: {
    //                 title: 'Wander wonder Travel Preset Pack',
    //                 price: 700
    //             }
    //         })
    //     }
    // }

    _goCheckout() {
        // if (process.env.NODE_ENV === `production` && typeof window !== undefined) {
        //     gtag('event', 'begin_checkout', {
        //         value: 700,
        //         currency: 'MXN',
        //         items: {
        //             title: 'Wander wonder Travel Preset Pack',
        //             price: 700
        //         }
        //     })
        // }

        const stripe = Stripe(`pk_live_6Y2HkZghX4OPFWpEtIZmdus900px9KedPg`)
        const successURL = `https://shop.alfrek.net/success`
        const cancelURL = `https://shop.alfrek.net/cancel`

        stripe.redirectToCheckout({
            items: [
                { sku: this.state.preset.sku, quantity: 1 }
            ],
            successUrl: successURL,
            cancelUrl: cancelURL,
        }).then((result: any) => {
            // If `redirectToCheckout` fails due to a browser or network
            // error, display the localized error message to your customer
            // using `result.error.message`.
            console.log(result.error.message)
        })
    }

    public render() {
        return (
            <section className={styles.Container}>
                <Header />
                <div className={styles.Presets}>
                    <div className={styles.Centered}>
                        <header>
                            <h1>
                                Get The Most Professional Travel Presets Available.
                                The Wonder Wander Travel Preset Pack Will Instantly
                                Turn Your Travel and Street Photos Into Epic Shots.
                            </h1>
                        </header>

                        <div className={styles.Overview}>
                            <div className={styles.Block}>
                                <h2>A Single Click. A Stunning Edit.</h2>

                                <p>
                                    The Wander Wonder Travel Preset Pack was created to
                                    instantly give your travel photos an absolutely
                                    gorgeous look. It includes:
                                </p>

                                <ul>
                                    <li>23 Lightroom Presets for travel photographs</li>
                                    <li>Vivid Landscapes</li>
                                    <li>Moody Street Shots</li>
                                    <li><strong>Compatible with Lightroom Mobile</strong></li>
                                    <li><strong>New Presets Added EVERY YEAR</strong></li>
                                </ul>
                            </div>
                            <div className={styles.Block}>
                                <img src={`/wander-wonder/photos/cover-2.jpg`} />
                            </div>
                        </div>
                        
                        <div className={styles.CallToAction}>
                            <div className={styles.Price}>
                                <p className={styles.Striked}>$45</p>
                                <p className={styles.Discounted}>
                                    ${this.state.preset.price}
                                    <small>Limited time only!</small>
                                </p>
                            </div>
                            {/* <a className={styles.ButtonPrimary} href={`/checkout?preset=wander-wonder`}> */}
                            <a className={styles.ButtonPrimary} href={`#`} onClick={this._goCheckout}>
                                <span>Buy Now</span>
                                <em>All transactions are 100% safe and secure.</em>
                            </a>
                            <img src={`/assets/images/credit-only.png`} />
                        </div>

                        <div className={styles.Grid}>
                            <div className={styles.Item}>
                                <img src={`/wander-wonder/photos/colima-2.jpg`} />
                                <h3>"Colima"</h3>
                            </div>

                            <div className={styles.Item}>
                                <img src={`/wander-wonder/photos/tijuana-2.jpg`} />
                                <h3>"Tijuana"</h3>
                            </div>
                        </div>

                        <div className={styles.PresetsGallery}>
                            <h1>A Preset for Every Situation.</h1>
                            <h2>23 presets - more added every year.</h2>

                            <div className={styles.Grid}>
                                <div className={styles.Item}>
                                    <img src={`/wander-wonder/photos/cdmx.png`} />
                                    <h3>"CDMX"</h3>
                                </div>

                                <div className={styles.Item}>
                                    <img src={`/wander-wonder/photos/tijuana.png`} />
                                    <h3>"Tijuana"</h3>
                                </div>

                                <div className={styles.Item}>
                                    <img src={`/wander-wonder/photos/chihuahua.png`} />
                                    <h3>"Chihuahua"</h3>
                                </div>

                                <div className={styles.Item}>
                                    <img src={`/wander-wonder/photos/colima.png`} />
                                    <h3>"Colima"</h3>
                                </div>

                                <div className={styles.Item}>
                                    <img src={`/wander-wonder/photos/yucatan.png`} />
                                    <h3>"Yucatán"</h3>
                                </div>

                                <div className={styles.Item}>
                                    <img src={`/wander-wonder/photos/sonora.png`} />
                                    <h3>"Sonora"</h3>
                                </div>

                                <div className={styles.Item}>
                                    <img src={`/wander-wonder/photos/quintana-roo.png`} />
                                    <h3>"Quintana Roo"</h3>
                                </div>

                                <div className={styles.Item}>
                                    <img src={`/wander-wonder/photos/monterrey.png`} />
                                    <h3>"Monterrey"</h3>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={styles.Lightroom}>
                        <div className={styles.Centered}>
                            <h1>Lightroom Mobile Compatible</h1>
                            <h3>Create beautiful images anywhere, anytime. No Creative Cloud Subscription needed.</h3>

                            <div className={styles.Steps}>
                                <div className={styles.Step}>
                                    <h4>Professional single-tap edits</h4>

                                    <img src={`/wander-wonder/photos/lightroom-step-1.jpg`} />
                                </div>

                                <div className={styles.Step}>
                                    <h4>Easily adjustable</h4>

                                    <img src={`/wander-wonder/photos/lightroom-step-2.jpg`} />
                                </div>

                                <div className={styles.Step}>
                                    <h4>Export directly to Instagram</h4>

                                    <img src={`/wander-wonder/photos/lightroom-step-3.jpg`} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={styles.Centered}>
                        <div className={styles.CallToAction}>
                            <div className={styles.Price}>
                                <p className={styles.Striked}>$45</p>
                                <p className={styles.Discounted}>
                                    ${this.state.preset.price}
                                    <small>Limited time only!</small>
                                </p>
                            </div>
                            <a className={styles.ButtonPrimary} href={`#`} onClick={this._goCheckout}>
                                <span>Buy Now</span>
                                <em>All transactions are 100% safe and secure.</em>
                            </a>
                            <img src={`/assets/images/credit-only.png`} />
                        </div>

                        <div className={styles.Faqs}>
                            <h1>FAQs</h1>

                            <h3>Who were these designed for?</h3>

                            <p>
                                These were designed with travel photographers, bloggers, influencers,
                                and even amateur photographers with aspirations of travel. Whether
                                you’re a professional travel or documentary photographer, or someone
                                that likes capturing emotion on the street outside their home, these
                                presets will help you tell stories about the beautiful places you visit.
                            </p>

                            <h3>What programs are these presets compatible with?</h3>

                            <p>
                                These presets are compatible with Lightroom Classic CC, Lightroom CC, and
                                Lightroom Mobile. When the presets are imported to Lightroom CC, they will
                                automatically be synced with your Lightroom Mobile app.
                            </p>

                            <h3>If I have any questions, can I send you an email?</h3>

                            <p>
                                Absolutely! I am always available for questions. You can contact me via
                                email at iam@alfrek.net or shoot me a direct DM on Instagram @alfrekjv.
                                I will respond to you as soon as I can.
                            </p>

                            <h3>Refund Policy</h3>

                            <p>
                                We do not issue refunds for digital products once the order is confirmed
                                and the product is sent. However, we review each request manually and
                                provide lifetime support.
                            </p>

                            <h3>How do I install them?</h3>

                            <p>
                                Installation is super easy! These presets work with both Lightroom CC and
                                Lightroom Classic CC. If you are using Lightroom CC, the presets will
                                automatically sync with Lightroom Mobile, so you can use these presets
                                on your mobile app.
                            </p>

                            <p>
                                For Lightroom Classic CC, simply go to your develop tab, find “Presets” in
                                the left hand column, click the (+) plus sign, and select import presets.
                                Import the file you downloaded after you purchased the presets. It should
                                be in your "Downloads" folder for both Mac and PC users.
                            </p>

                            <p>
                                For Lightroom CC, the process is similar. Click “Presets” in the bottom
                                right hand corner of the application, then select “Import presets”. Simply
                                import the file you downloaded after you purchased the presets and you are
                                good to go. These presets will sync with your Lightroom Mobile, so you can
                                access them using your phone 🙂 
                            </p>
                        </div>

                        <div className={styles.CallToAction}>
                            <div className={styles.Price}>
                                <p className={styles.Striked}>$45</p>
                                <p className={styles.Discounted}>
                                    ${this.state.preset.price}
                                    <small>Limited time only!</small>
                                </p>
                            </div>
                            <a className={styles.ButtonPrimary} href={`#`} onClick={this._goCheckout}>
                                <span>Buy Now</span>
                                <em>All transactions are 100% safe and secure.</em>
                            </a>
                            <img src={`/assets/images/credit-only.png`} />
                        </div>
                    </div>
                </div>
                <Footer />
            </section>
        )
    }
}